import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rfiFeedbackClient } from '../../lib/connect/clients';
export function useRfiFeedbackHistory(rfiResponseProjectId) {
    return useQuery({
        queryKey: [
            'rfi-feedback-history',
            rfiResponseProjectId
        ],
        enabled: !!rfiResponseProjectId,
        retry: false,
        queryFn: async ()=>(await rfiFeedbackClient.getRfiFeedbackHistory({
                rfiResponseProjectId
            })).history
    });
}
export function useProposalRfiHistory(proposalProjectId) {
    return useQuery({
        queryKey: [
            'proposal-rfi-history',
            proposalProjectId
        ],
        enabled: !!proposalProjectId,
        retry: false,
        queryFn: ()=>rfiFeedbackClient.listProposalRfiHistory({
                proposalProjectId
            })
    });
}
export function useRfiFeedbackTargets(rfiResponseProjectId) {
    return useQuery({
        queryKey: [
            'rfi-feedback-targets',
            rfiResponseProjectId
        ],
        enabled: !!rfiResponseProjectId,
        retry: false,
        queryFn: async ()=>(await rfiFeedbackClient.listRfiFeedbackTargets({
                rfiResponseProjectId
            })).targets
    });
}
export function useRecordRfiFeedback() {
    const cache = useQueryClient();
    return useMutation({
        mutationFn: (args)=>rfiFeedbackClient.recordRfiFeedbackVersion(args),
        onSuccess: (_data, args)=>{
            void cache.invalidateQueries({
                queryKey: [
                    'rfi-feedback-history',
                    args.rfiResponseProjectId
                ]
            });
            void cache.invalidateQueries({
                queryKey: [
                    'proposal-rfi-history'
                ]
            });
        }
    });
}
export function useAdoptRfiFeedback() {
    const cache = useQueryClient();
    return useMutation({
        mutationFn: (args)=>rfiFeedbackClient.adoptRfiFeedback(args),
        onSuccess: (_data, args)=>{
            for (const queryKey of [
                [
                    'rfi-feedback-history',
                    args.rfiResponseProjectId
                ],
                [
                    'rfi-feedback-targets',
                    args.rfiResponseProjectId
                ],
                [
                    'proposal-rfi-history'
                ],
                [
                    'customer-themes',
                    args.captureProjectId
                ],
                [
                    'customer-theme',
                    args.captureProjectId,
                    args.targetId
                ],
                [
                    'capture-solution',
                    args.captureProjectId
                ]
            ])void cache.invalidateQueries({
                queryKey
            });
        }
    });
}
